import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { CardVerification, CardVerificationReject } from '../../details/types'
import { getCardVerification } from '../../details'
import { RejectCardVerification } from './types'
import { cardVerificationStatus } from '../../const'
import { cardVerificationRequestMounted } from '../../details/model'
import { setRequestSuccess, setRequestError } from '../../../../features/notifications'

export const mounted = createEvent()
export const unmounted = createEvent()

export const setReject = createEvent<RejectCardVerification>()
export const $reject = restore<RejectCardVerification>(setReject, {
  comment: '',
})

// submit reject

export const submitReject = createEvent<CardVerificationReject>()

export const rejectCardVerification = fx<
  CardVerificationReject,
  CardVerification
>({
  method: 'PUT',
  url: `/client_purse`,
})

sample({
  clock: submitReject,
  fn: ({ requestId, status, comment }) => {
    return {
      body: {
        requestId: requestId,
        status: cardVerificationStatus.cardVerificationRequestStatusRejected(),
        comment: comment,
      },
      url: `/client_purse/${requestId}`,
    }
  },
  target: rejectCardVerification,
})

// clear field on success

sample({
  clock: rejectCardVerification.done,
  fn: () => ({}),
  target: [
    cardVerificationRequestMounted,
    setReject.prepend(() => ({
      comment: '',
    })),
  ],
})

sample({
  clock: rejectCardVerification.done,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: rejectCardVerification.fail,
  fn: ({ error }) => ({
    message: (error as any)?.body?.message || (error as any)?.message || 'Unknown error',
    code: (error as any)?.status || 0,
  }),
  target: setRequestError,
})

sample({
  clock: [mounted, unmounted],
  fn: () => ({
    comment: '',
  }),
  target: $reject,
})
